@import '../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.ddp-toast {
  position: fixed;
  bottom: @space-24;
  right: @space-24;
  max-width: 320px;
  width: calc(100vw - 48px);
  height: 372px;
  background: @white;
  border-radius: 8px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 100;
  overflow: hidden;
}

.close-button {
  position: absolute;
  top: @space-12;
  right: @space-12;
  width: 24px;
  height: 24px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  color: var(--gray-56595D);
  font-size: 12px;

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: var(--gray-0F0F10);
  }

  &:focus {
    outline: 2px solid var(--blue-1D5AD8);
    outline-offset: 2px;
  }
}

.toast-content {
  height: 100%;
  flex-direction: column;
}

.graphic-section {
  height: 157px;
  width: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ddp-graphic {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ddp-graphic::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: url('./duties-and-taxes-header.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.text-section {
  padding: @space-12;
  height: 188px;
  background-color: @white;
  flex-direction: column;
  justify-content: flex-start;
}

.modal-title {
  font-weight: @bold;
  font-size: 20px;
  line-height: 28px;
  color: var(--gray-0F0F10);
  text-align: left;
  margin-bottom: @space-8;
}

.modal-description {
  color: var(--gray-212c36);
  line-height: 24px;
  text-align: left;
  margin-bottom: @space-16;
  flex: 1;
}

.actions-section {
  flex-direction: row;
  gap: @space-12;
  align-items: center;
  justify-content: flex-start;
  margin-top: auto;
  flex-shrink: 0;
}

.accept-button {
  flex: 0 0 auto;
  padding: @space-8 @space-16;
  background-color: var(--green-0D6E3F);
  border-color: var(--green-0D6E3F);
  color: @white;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  min-width: 132px;
  height: 40px;

  &:hover {
    background-color: var(--green-0B5C35);
    border-color: var(--green-0B5C35);
  }

  &:focus {
    background-color: var(--green-0B5C35);
    border-color: var(--green-0B5C35);
    box-shadow: 0 0 0 2px var(--green-D8FFEB);
  }
}

.remind-later-link {
  flex: 0 0 auto;
  /*We need this to get transparent button*/
  background: none;
  border: none;
  padding: @space-8;
  color: var(--blue-1D5AD8);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  margin-left: @space-8;

  &:hover {
    color: var(--blue-006FBB);
    text-decoration: none;
    /*We need this to get transparent button*/
    background: none;
  }

  &:focus {
    color: var(--blue-006FBB);
    outline: 2px solid var(--blue-DBECFE);
    outline-offset: 2px;
    /*We need this to get transparent button*/
    background: none;
  }
}
